export enum MeasurementSystem {
	Metrics = 'metric',
	Imperial = 'imperial'
}

export type ImperialDistanceUnit = 'feet' | 'inches';